import { render, staticRenderFns } from "./MedicineTable.vue?vue&type=template&id=243d9f44&scoped=true"
import script from "./MedicineTable.vue?vue&type=script&lang=js"
export * from "./MedicineTable.vue?vue&type=script&lang=js"
import style0 from "./MedicineTable.vue?vue&type=style&index=0&id=243d9f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d9f44",
  null
  
)

export default component.exports